module.exports = __webpack_public_path__ + "media/images/icons/icons_small/41_key-d270dc62a6e8ea66b5d0661bcf14d9db.png";